import { useCallback, useState } from 'react'

import { useSegment } from '../../../../../../../hooks'
import { documentsTabs } from '../constants/documentsTabs'
import { DocumentType } from '../enums/DocumentType'
import { DocumentTabItem } from '../types/DocumentTabItem'

interface DocumentsTabs {
  activeTab: DocumentType
  selectTab: (documentType: DocumentType) => void
  tabs: DocumentTabItem[]
}

export const useDocumentsTabs = (): DocumentsTabs => {
  const { track } = useSegment()
  const [activeTab, setActiveTab] = useState<DocumentType>(DocumentType.INVOICE)

  const selectTab = useCallback(
    (tabName: DocumentType) => {
      track('XXX - Invoicing Commerce - Client Details - Documents List Tab clicked', {
        tab: tabName === DocumentType.INVOICE ? 'invoices' : 'quotes',
      })
      setActiveTab(tabName)
    },
    [setActiveTab, track],
  )

  return {
    activeTab,
    selectTab,
    tabs: documentsTabs,
  }
}
